import React from 'react';
// Images
import images from '../../assets/images/images';

interface ISpriteImage extends React.HTMLProps<HTMLDivElement> {
    className: string;
}

export const SpriteImage = (props: ISpriteImage): JSX.Element => {
    return <div {...props} style={{ backgroundImage: `url(${images.sprite})` }} className={props.className || ''} />;
};
